var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.378 12c0-6.63 5.377-12 12-12 6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12Zm6.167-4.773 1.06-1.06 4.774 4.772 4.772-4.773 1.061 1.061L13.44 12l4.773 4.773-1.06 1.06-4.774-4.772-4.773 4.773-1.06-1.061L11.318 12 6.545 7.227Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ErrorFilled.dc42437c69e01ce754029c2cd58f9dc5.svg";